import { z } from 'zod';
import { getDefaults, Validation } from '@mews/framework';
import { AccountNoteCustomerClassifications } from '@mews-commander/data-access';
import { maxAccountNoteInputLength } from '@mews-commander/legacy-form';

export enum NoteType {
    guest = 'guest',
    reservation = 'reservation',
}

export const fieldNames = {
    accountId: 'accountId',
    classification: 'classification',
    content: 'content',
    text: 'text',
    noteType: 'noteType',
} as const;

const guestNoteFormSchema = z.object({
    [fieldNames.accountId]: Validation.String.Required.default(''),
    [fieldNames.classification]: z
        .nativeEnum(AccountNoteCustomerClassifications)
        .default(AccountNoteCustomerClassifications.FrontOffice),
    [fieldNames.content]: Validation.String.Required.max(maxAccountNoteInputLength.maximum).default(''),
    [fieldNames.noteType]: z.literal(NoteType.guest).default(NoteType.guest),
});

const reservationNoteFormSchema = z.object({
    [fieldNames.noteType]: z.literal(NoteType.reservation).default(NoteType.reservation),
    [fieldNames.text]: Validation.String.Required.default(''),
});

export const schema = z.discriminatedUnion(fieldNames.noteType, [guestNoteFormSchema, reservationNoteFormSchema]);
export const defaultGuestValues = getDefaults(guestNoteFormSchema) as FormValues;
export const defaultReservationValues = getDefaults(reservationNoteFormSchema) as FormValues;

export type FormValues = z.infer<typeof schema>;
